import { on } from '@ngrx/store';
import { ContentId } from '../../../types/content-block';
import { FunctionalElement } from '../../../types/functional-element';
import { updateFunctionalElementRemarks } from '../../actions/functional-elements.actions';
import { FormState } from '../../state/form.state';
import { updateStateAfterContentChanges } from './form-reducer.utilities';

export function updateFunctionalElementRemarksReducer(
    state: Readonly<FormState>,
    props: { id: ContentId; newValue: string },
): Readonly<FormState> {
    const oldFunctionalElement = state.participantCopies[state.selectedParticipantCopyId].functionalElements[props.id];

    if (oldFunctionalElement.remarks === props.newValue) {
        return state;
    }

    const newFunctionalElement: { [key: string]: FunctionalElement } = {
        [props.id]: {
            ...oldFunctionalElement,
            remarks: props.newValue,
        },
    };

    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newFunctionalElement,
    });
}

export const remarksReducer = [
    on<FormState, Array<typeof updateFunctionalElementRemarks>>(
        updateFunctionalElementRemarks,
        updateFunctionalElementRemarksReducer,
    ),
];
